import * as React from 'react';

import { DASHBOARD_UNAUTHORIZED_WARNING } from 'src/ui/constants/testIds';
import { copy } from 'src/ui/templates/copy';
import { buildRoute } from 'src/ui/utils/buildRoute';

interface UnauthorizedWarningProps {
  index: number;
  org: string | undefined;
}

/**
 * This uses just a plain button as we use an image to display the actual
 * button. We don't want this to be styled by blueprintjs.
 */
export const UnauthorizedWarning: React.VFC<UnauthorizedWarningProps> = ({
  index,
  org,
}) => {
  return (
    <div className="sd-warning">
      {copy.errors.unauthorized.before}
      &nbsp;
      <a
        href={buildRoute(org, index, 'diagnostic')}
        data-testid={DASHBOARD_UNAUTHORIZED_WARNING}
      >
        {copy.errors.unauthorized.link} &rarr;
      </a>
      &nbsp;
      {copy.errors.unauthorized.after}
    </div>
  );
};
